import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import './List.css';
/**
 * Компонент обертка вокруг списка компонентов Card
 */
const List = ({ children }) => {
	const mode = useSelector(state => state.filter.mode);
	const [ style, setStyle ] = useState('List-' + mode);

	// Если сменили режим отображения, меняем стиль списка
	useEffect(() => {
		setStyle('List-' + mode);
	}, [ mode ]);

	return (
        <div className={style}>
            {children}
        </div>
	);
};

List.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
};

export default List;
